export default "__VITE_ASSET__DWOhgvng__"